import { environment } from '@core/environment';
import { GrpcRestFetchTransport, useAuth0Interceptor } from '@deepup/api-utils';
import { commonApiV1 as commonApi, scanCategoryApiV1 as scanCategoryApi } from '@deepup/apis';
import {
  iscanApiV1 as iscanApi,
  iscanClientApiV1 as iscanClientApi,
  iorganizationManagementApiV1 as iorganizationManagementApi,
} from '@deepup/internal-apis';
import { useMemo } from 'react';

export const useScanInfo = () => {
  const authInterceptor = useAuth0Interceptor();

  const client = useMemo(() => {
    const transportRest = new GrpcRestFetchTransport({
      baseUrl: environment.unifiedApiUrl,
      fetchInit: {
        credentials: 'include',
      },
      interceptors: [authInterceptor],
    });

    return new iscanClientApi.InternalScanServiceClient(transportRest);
  }, [authInterceptor]);

  const getScanInfo = async (scanId: string, projectId: string) => {
    try {
      const response = await client.listScanInfos({
        projectIds: [projectId],
        scanIds: [scanId],
        deviceIds: [],
        surfaceClassificationLabels: [],
        qaState: iscanApi.QAState.NONE,
        sortBy: iscanApi.StreamScanInfosRequest_SortBy.UNSPECIFIED,
        sortOrder: commonApi.SortOrder.ASC,
        scanCategoryKind: scanCategoryApi.ScanCategoryKind.UNSPECIFIED,
        scanCategoryKinds: [],
        qaStates: [],
        exportStatusCodes: [],
        labelingType: iorganizationManagementApi.LabelingType.UNSPECIFIED,
      }).response;

      // The response contains items array, each item has a scan property
      const scanInfo = response.items?.find((item) => item.scan?.id === scanId);
      return scanInfo;
    } catch (err) {
      console.error('Error fetching scan info:', err);
      throw err;
    }
  };

  return { getScanInfo };
};
